export enum StatusEnum {
  SUCCESS = "success",
  ERROR = "error",
  INFO = "info"
}
